import Hosts from '../../../Hosts';

const object_type = 'Empresa01'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/entities`
const api_list_route = companycode => `${Hosts.SIMCore_API}/entities/list/${companycode}/${object_type}`

const base_endpoint = '/empresa01'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    view: `${base_endpoint}_view`,
}

const data_interface = {
    id: '',
    info: {
        companycode: '',
        username: '',
        password: '',
        name: '',
        rgpd: false,
        ativo: true,
        vat: '',

        projetos: [{
            codProjeto: '1',
            nome: [{
                tipo: {},
                linha: {},

            }],
            nLicenca: '',
            dataInicio: '',    // ver tipo dados
            dataFim: '',       // ver tipo daddos
            assistenciaRemota: false,
            tempoAssistencia: '',  // timer
            assistenciaPermitida: false,


        }], // adssssssssssssssssssssssssssssssssssssssssssssss
        identificacao: {
            tipo_identificacao: '',
            numero_identificacao: '',
            validade_identificacao: ''
        },
        observation: '',
        entity_type: ''
    },
    addresses: [{
        village: '',
        city: '',
        type: [],
        region: '',
        country: '',
        apartado: '',
        localidade: '',
        contats: [],
        principal: '',
        observation: '',
        postal_code: '',
        street_name: '',
        address_detail: '',
    }],
    contacts: [{
        email: '',
        phone: '',
        principal: 'true',
        extensions: [],
        observation: '',
        mobile_phone: '',
        building_number: '',
        departamentos: [
            { id: 1, nome: 'Comunicação Interna' },
            { id: 2, nome: 'Financeiro' },
            { id: 3, nome: 'Gestão' },
            { id: 4, nome: 'Informática' },
            { id: 5, nome: 'Jurídico' },
            { id: 6, nome: 'Logística' },
            { id: 7, nome: 'Multimédia' },
            { id: 8, nome: 'Pesquisa e Desenvolvimento' },
            { id: 9, nome: 'Produção' },            
            { id: 10, nome: 'Recursos Humanos' },
            { id: 11, nome: 'Suporte ao Cliente' },
            { id: 12, nome: 'Tecnologias de Internet' },                   
        ],
        person_responsables: [{/*
            name: '',
            email: '',
            observation: '',
            mobile_phone: '',
        */},
            { id: '1', name: 'Mário Silva', email: 'mariosilva@email.com', mobile_phone: '962348291', resp: 'ASSEC', observation: '', departamentos: [1],  },
            { id: '2', name: 'Joana Mendes', email: 'joanamendes@email.com', mobile_phone: '963450382', resp: 'ASSEC', observation: '', departamentos: [2, 4]},
            { id: '3', name: 'Mariana Pereira', email: 'marianapereira@email.com', mobile_phone: '964560473', resp: 'ASSEC', observation: '', departamentos: [3, 5]},
            { id: '4', name: 'Vitor Martins', email: 'vitormartins@email.com', mobile_phone: '965670584', resp: 'ASSEC', observation: '', departamentos: [4, 6]},
            { id: '5', name: 'Maria Domingues', email: 'mariadomingues@email.com', mobile_phone: '966780695', resp: 'ASSEC', observation: '', departamentos: [5, 7]},
            { id: '6', name: 'Tânia Matias', email: 'taniamatias@email.com', mobile_phone: '967890716', resp: 'ASSEC', observation: '', departamentos: [6, 8]},
            { id: '7', name: 'Júlio Salcedas', email: 'ricardoalmeida@email.com', mobile_phone: '968900827', resp: 'ASSEC', observation: '', departamentos: [7, 9]},
            { id: '8', name: 'Ricardo Almeida', email: 'ricardoalmeida@email.com', mobile_phone: '969010938', resp: 'ASSEC', observation: '', departamentos: [8, 10]},
            { id: '9', name: 'Tiago Fernandes', email: 'tiagofernandes@email.com', mobile_phone: '960120049', resp: 'ASSEC', observation: '', departamentos: [9, 11]},
            { id: '10', name: 'Catarina Nunes', email: 'catarinanunes@email.com', mobile_phone: '961230150', resp: 'ASSEC', observation: '', departamentos: [10, 12]},
            { id: '11', name: 'Bruno Rodrigues', email: 'brunorodrigues@email.com', mobile_phone: '962340261', resp: 'ASSEC', observation: '', departamentos: [1, 11]},
            { id: '12', name: 'Sofia Oliveira', email: 'sofiaoliveira@email.com', mobile_phone: '963450372', resp: 'ASSEC', observation: '', departamentos: [1, 12]},
        ],
        clientes: [
            { id: '1', prioridade: '', data: '', nome: 'Garcia & Filhos', email: 'contact@garciaefilhos.com', mobile_phone: '962348291', descricao: '', codProjeto: [1], responsavel: '' },
            { id: '2', prioridade: '', data: '', nome: 'Padaria PAIFI, Lda', email: 'contact@padariapaifi.com',  mobile_phone: '963450382', descricao: '', codProjeto: [2, 4], responsavel: '' },
            { id: '3', prioridade: '', data: '', nome: 'Casa da Isabel', email: 'contact@casadaisabel.com', mobile_phone: '964560473', descricao: '', codProjeto: [3, 5], responsavel: '' },
            { id: '4', prioridade: '', data: '', nome: 'Fábrica Pastelaria S. Silvestre, Lda', email: 'contact@pastelariasilvestre.com', mobile_phone: '965670584', descricao: '', codProjeto: [4, 6], responsavel: '' },
            { id: '5', prioridade: '', data: '', nome: 'Padaria Camponesa', email: 'contact@padariacamponesa.com', mobile_phone: '966780695', descricao: '', codProjeto: [4, 6], responsavel: '' },
            { id: '6', prioridade: '', data: '', nome: 'Mirador & Garcia, Lda', email: 'contact@miradoregarcia.com', mobile_phone: '967890716', descricao: '', codProjeto: [3, 5], responsavel: '' },
            { id: '7', prioridade: '', data: '', nome: 'Padaria Popular de José Armando S. Luís, Lda', email: 'contact@padariapopular.com', mobile_phone: '968900827', descricao: '', codProjeto: [2, 4], responsavel: '' },
            { id: '8', prioridade: '', data: '', nome: 'Panificadora Sul do Cávado, Lda', email: 'contact@suldacavado.com', mobile_phone: '969010938', descricao: '', codProjeto: [7, 8], responsavel: '' },
            { id: '9', prioridade: '', data: '', nome: 'Confeitaria Pôr do Sol, Lda', email: 'contact@pordosolconfeitaria.com', mobile_phone: '960120049', descricao: '', codProjeto: [2, 6], responsavel: '' },
            { id: '10', prioridade: '', data: '', nome: 'Doce Tentação, Lda', email: 'contact@docetentacao.com', mobile_phone: '961230150', descricao: '', codProjeto: [1, 2], responsavel: '' },
            { id: '11', prioridade: '', data: '', nome: 'Panificadora Estrela, Lda', email: 'contact@panificadoraestrela.com', mobile_phone: '962340261', descricao: '', codProjeto: [1, 6], responsavel: '' },
            { id: '12', prioridade: '', data: '', nome: 'Pão Quente & Companhia, Lda', email: 'contact@paoquentecompanhia.com', mobile_phone: '963450372', descricao: '', codProjeto: [3, 4], responsavel: '' }
        ], 
    }],
    profile: { name: "Empresa01" },
    notifications: []
}

export {
    object_type,
    endpoints,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route
}
